import styled from '@emotion/styled'

import {Icon} from '@vio/atlas/Icon'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import mirror from '@vio/atlas/src/utils/mirror'
import {cssTheme} from '@vio/atlas/themes'
import {linariaMq} from '@vio/atlas/utils/breakpoints'

export const BackToGalleryIconButton = styled(Icon)`
  ${mirror()}
`

export const SkeletonLoaderContainer = styled(SkeletonLoader)`
  &.--gallery-loading-image {
    height: 163px !important;
    ${linariaMq.desktopMd} {
      height: 219px !important;
    }
  }
`

export const GalleryImageScrollWrapper = styled.div`
  height: 100%;
  overflow: scroll;
  padding: ${cssTheme.layout.spacing.s400};
  padding-top: 0;
  -ms-overflow-style: none; /* for Internet Explorer, Edge */
  scrollbar-width: none; /* for Firefox */
  &::-webkit-scrollbar {
    display: none; /* for Chrome, Safari and Opera */
  }

  &.--has-no-more-images-message {
    padding-bottom: ${cssTheme.layout.spacing.s950};
  }

  &.--is-loading-wrapper {
    padding-bottom: ${cssTheme.layout.spacing.s900};
  }
  &.--has-selected-image {
    display: none;
  }
`

export const GridGallery = styled.div`
  display: grid;
  gap: ${cssTheme.layout.spacing.s300};
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: 163px;
  img {
    cursor: pointer;
  }
  ${linariaMq.desktopSm} {
    grid-auto-rows: 219px;
  }
`

export const GalleryCategoriesWrapper = styled.div`
  display: flex;
  gap: ${cssTheme.layout.spacing.s400};
  align-items: center;
  padding: ${cssTheme.layout.spacing.s400};
  .--gallery-category-item p {
    ${cssTheme.typography.labelS}
  }
`
